import { render, staticRenderFns } from "./RefFilesDash.vue?vue&type=template&id=0686933c&scoped=true"
import script from "./RefFilesDash.vue?vue&type=script&lang=js"
export * from "./RefFilesDash.vue?vue&type=script&lang=js"
import style0 from "./RefFilesDash.vue?vue&type=style&index=0&id=0686933c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0686933c",
  null
  
)

export default component.exports